import { styled } from 'src/styles/stitches.config'

export const Wrapper = styled('div', {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '120vh',
    width: '100%',
    overflow: 'hidden',

    '@mdDown': {
        flexDirection: 'column',
        gap: '$md',
        height: '110vh',
    },
})

export const MarqueeWrapper = styled('div', {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 1,
    '.swiper-wrapper': {
        'transition-timing-function': 'linear',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
    },
    '.swiper-slide': {
        width: 'auto',
        paddingLeft: 'calc($colWidth * 0.5)',
        paddingRight: 'calc($colWidth * 0.5)',
    },

    '@mdDown': {
        position: 'relative',
        top: 0,
        left: 0,
        transform: 'none',
        width: '100%',
        paddingLeft: '0',
        paddingRight: '0',
    },
})

export const MarqueeIcon = styled('div', {
    width: 'calc(0.8 * $colWidth)',
})

export const ContentWrapper = styled('div', {
    position: 'relative',
})

export const ImageWrapper = styled('div', {
    width: 'calc(10 * $colWidth)',
    '@mdDown': {
        width: '100%',
    },
})

export const TextWrapper = styled('div', {
    position: 'absolute',
    top: '100%',
    right: '$colWidth',
    transform: 'translateY(-50%)',
    width: 'calc(5 * $colWidth)',
    paddingRight: '$colWidth',

    '@mdDown': {
        position: 'relative',
        top: 0,
        right: 'auto',
        transform: 'none',
        width: 'calc(100% - 60px)',
        paddingLeft: '$sm',
        paddingRight: '$sm',
        marginTop: '-$md',
    },
})
